var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32 0C1.93413 0 0 1.93413 0 4.32V31.68C0 34.0659 1.93413 36 4.32 36H31.68C34.0659 36 36 34.0659 36 31.68V4.32C36 1.93413 34.0659 0 31.68 0H4.32ZM22.9068 25.0079C23.1312 24.9287 23.3952 24.7571 23.6988 24.4931C24.1476 24.1103 24.3654 23.7671 24.3522 23.4635C24.3522 23.1599 24.1674 22.8035 23.7978 22.3943L19.9877 17.9452L23.7978 13.5041C24.1674 13.1081 24.3522 12.7517 24.3522 12.4349C24.3654 12.1181 24.1476 11.7683 23.6988 11.3855C23.4084 11.1083 23.151 10.9301 22.9266 10.8509C22.7022 10.7717 22.4844 10.7849 22.2732 10.8905C22.062 10.9961 21.831 11.2007 21.5802 11.5043L18.0261 15.6545L14.472 11.5043C14.2212 11.2007 13.9902 10.9961 13.779 10.8905C13.5678 10.7849 13.35 10.7717 13.1256 10.8509C12.9012 10.9301 12.6438 11.1083 12.3534 11.3855C11.9178 11.7683 11.7 12.1181 11.7 12.4349C11.7 12.7517 11.8848 13.1081 12.2544 13.5041L16.0645 17.9452L12.2544 22.3943C11.8848 22.8035 11.7 23.1599 11.7 23.4635C11.7 23.7671 11.9178 24.1103 12.3534 24.4931C12.657 24.7571 12.921 24.9287 13.1454 25.0079C13.3698 25.0871 13.5876 25.0739 13.7988 24.9683C14.01 24.8627 14.2344 24.6647 14.472 24.3743L18.0261 20.2316L21.5802 24.3743C21.831 24.6647 22.0554 24.8627 22.2534 24.9683C22.4646 25.0739 22.6824 25.0871 22.9068 25.0079Z",
    fill: "#6C9DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.8098d00210fc8d093237ba7e4b76e820.svg";
export { ForwardRef as ReactComponent };